import {
  MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW,
  MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_SUCCESS,
  MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_FAILURE,
  MULTISTEP_REACTION_DIALOG_ADD_PROJECT,
  MULTISTEP_REACTION_DIALOG_ADD_PROJECT_SUCCESS,
  MULTISTEP_REACTION_DIALOG_ADD_PROJECT_FAILURE,
  MULTISTEP_REACTION_DIALOG_CLEAR_STATE,
} from './constants';

export const initialState = {
  isLoading: false,
  response: null,
  error: null,
  addProjectIsLoading: false,
  addProjectResponse: null,
  addProjectError: null,
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW:
      return { ...state, isLoading: true, response: null, error: null };
    case MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_SUCCESS:
      return { ...state, isLoading: false, response: action.payload, error: null };
    case MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_FAILURE:
      return { ...state, isLoading: false, response: null, error: action.payload };
    case MULTISTEP_REACTION_DIALOG_ADD_PROJECT:
      return { ...state, addProjectIsLoading: true, addProjectResponse: null, addProjectError: null };
    case MULTISTEP_REACTION_DIALOG_ADD_PROJECT_SUCCESS:
      return { ...state, addProjectIsLoading: false, addProjectResponse: action.payload, addProjectError: null };
    case MULTISTEP_REACTION_DIALOG_ADD_PROJECT_FAILURE:
      return { ...state, addProjectIsLoading: false, addProjectResponse: null, addProjectError: action.payload };
    case MULTISTEP_REACTION_DIALOG_CLEAR_STATE:
      return { ...initialState };
    default: {
      return state;
    }
  }
}
